import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-periodo-segmentado',
  templateUrl: './periodo-segmentado.component.html',
  styleUrls: ['./periodo-segmentado.component.scss']
})
export class PeriodoSegmentadoComponent {
  @Input() periodos: Array<{ valor: string; label: string }> = [];
  @Input() selecionado: string = '';
  @Input() disabled = false;
  @Output() periodoSelecionado = new EventEmitter<string>();

  selecionar(valor: string): void {
    if (this.disabled || valor === this.selecionado) {
      return;
    }

    this.periodoSelecionado.emit(valor);
  }
}
